import React from 'react';

interface MultiSelectFieldProps {
  label: string;
  selectedKeys: string[];
  allKeys: string[];
  onSelectionChange: (selectedKeys: string[]) => void;
}

const MultiSelectField: React.FC<MultiSelectFieldProps> = ({
  label,
  selectedKeys,
  allKeys,
  onSelectionChange
}) => {
  const handleToggleKey = (key: string) => {
    if (selectedKeys.includes(key)) {
      onSelectionChange(selectedKeys.filter(k => k !== key));
    } else {
      onSelectionChange([...selectedKeys, key]);
    }
  };

  const handleSelectAll = () => {
    onSelectionChange([...allKeys]);
  };

  const handleDeselectAll = () => {
    onSelectionChange([]);
  };

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <label className="text-sm font-medium text-gray-300">{label}</label>
        <div className="space-x-2">
          <button
            type="button"
            onClick={handleSelectAll}
            className="text-xs px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Select All
          </button>
          <button
            type="button"
            onClick={handleDeselectAll}
            className="text-xs px-2 py-1 bg-gray-600 text-white rounded hover:bg-gray-700"
          >
            Deselect All
          </button>
        </div>
      </div>
      <div className="max-h-32 overflow-y-auto border border-gray-600 rounded p-2">
        {allKeys.map(key => (
          <label key={key} className="flex items-center space-x-2 py-1">
            <input
              type="checkbox"
              checked={selectedKeys.includes(key)}
              onChange={() => handleToggleKey(key)}
              className="rounded border-gray-600 bg-gray-700 text-blue-600 focus:ring-blue-500"
            />
            <span className="text-sm text-gray-300">{key}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default MultiSelectField; 